import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        fontFamily: "'Poppins', sans-serif",
        textAlign: 'center',
        padding: '40px 20px',
      }}
    >
      <div>
        <h1 style={{ fontSize: '96px', margin: '0 0 8px', color: '#111' }}>404</h1>
        <h2 style={{ fontSize: '24px', margin: '0 0 16px', color: '#333', fontWeight: 600 }}>
          Sayfa Bulunamadı
        </h2>
        <p style={{ fontSize: '16px', color: '#666', marginBottom: '32px', maxWidth: '460px' }}>
          Aradığınız sayfa taşınmış veya kaldırılmış olabilir.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            backgroundColor: 'rgb(16, 190, 132)',
            color: '#ffffff',
            borderRadius: '0',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '16px',
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
